import React from 'react';

const ServicoContext = React.createContext();

export default ServicoContext;
